<template>
  <PopUp
    v-if="popUpActive"
    bottom
    :clickOutsideClose="false"
    :popUpActive="popUpActive"
    @click="$_onClosePopup()"
  >
    <LvTabs
      v-if="popUpActive"
      :items="tabs.items"
      :value="_selectedTabId"
      :isDisabled="isLoading.content || isLoading.submit"
      :isLoading="isLoading.content || isLoading.submit"
      class="mb-20"
      @input="$_onClickTab($event)"
    />
    <WsTextChip001
      v-if="_selectedTabId !== 'unit'"
      thin
      small
      leadingIcon="icon-warning"
      :textLabel="_warningText"
      class="mb-20"
    />
    <div v-if="_selectedTabId === 'local'">
      <ValidationObserver ref="formObserver">
        <div class="input-item mt-20 mb-16">
          <StateInputButton
            v-model="createFile.name"
            required
            title="標題"
            rules="required|slash"
            placeholder="輸入"
          />
        </div>
        <LvUploadFileList
          v-model="createFile.attaches"
          upload
          oneFile
          required
          showDeleteBtn
          saveToStorage
          rules="required"
          :download="false"
          :acceptFileType="acceptFileType"
          class="lv-popup-choose-file__upload-file-list"
          @input="$_onChooseFile($event)"
        />
      </ValidationObserver>
    </div>
    <div v-else>
      <LvStateRadioBtn
        v-model="attachType"
        required
        isNarrow
        textSize="h6"
        title="關聯版本設定"
        :state="attachType"
        :disable="isLoading.content"
        :radioButtonItem="_attachTypeRadio"
        class="mb-20"
      />
      <LvText h6 bold class="mb-4">{{ $t('已選擇的檔案') }}</LvText>
      <LvText v-if="!selectFileList.length" h6>{{ `(${$t('尚未選取檔案')})` }}</LvText>
      <LvFlexBox class="mb-16">
        <WsButton001
          v-for="(file, fileIndex) in selectFileList"
          :key="fileIndex"
          outLine
          nonMinWidth
          trailingIcon="icon-cancel"
          :style="{ 'min-height': '32px' }"
          class="mb-4 mr-4"
          @click="$_onRemoveFileFromSelected(file)"
        >
          {{ `${file.name} ${file.versionNumber}` }}
        </WsButton001>
      </LvFlexBox>
      <LvDataTable
        v-if="popUpActive"
        ref="LvDataTable"
        :fetchUrl="_fetchUrl"
        :setParams="$_setParams"
        :setListData="$_setListData"
        :columnHeader="columnHeader"
        :filterFieldTypes="filterFieldTypes"
        @loading="$_onLoading($event)"
        @data-click="$_onClickItem($event)"
      >
        <template v-slot:columnHeader="{ columnHeaderItem }">
          <LvCheckbox
            v-if="columnHeaderItem.id === 'isChecked' && !oneFile"
            h3
            exclusive
            lightGray
            :value="true"
            :select="isSelectAll"
            @change="$_onSelectAll($event)"
          />
        </template>
        <template v-slot:item="{ rowItem, columnHeaderItem }">
          <div v-if="columnHeaderItem.id === 'name'" class="ml-8">
            <LvText h5 class="my-4">{{ rowItem.name }}</LvText>
            <LvText h6 lightGray class="mb-4">{{ rowItem.versionNumber }}</LvText>
            <LvText
              v-for="(remark, remarkIndex) in rowItem.textRemark"
              :key="remarkIndex"
              h6
              lightGray
              >{{ $t(remark) }}</LvText
            >
          </div>
          <LvCheckbox
            v-if="columnHeaderItem.id === 'isChecked'"
            h3
            exclusive
            lightGray
            :value="true"
            :select="rowItem.isChecked"
            @change="$_onChangeSelectFile($event, rowItem)"
          />
        </template>
      </LvDataTable>
    </div>
    <template v-slot:bottomBtn>
      <WsButton001 outLine @click="$_onClosePopup()">
        {{ $t('取消') }}
      </WsButton001>
      <WsButton001 :isloading="isLoading.submit" :disable="!_isSubmittable" @click="$_onSubmit()">
        {{ $t('確定') }}
      </WsButton001>
    </template>
    <LvPopupPreview
      download
      :url="previewPopup.url"
      :name="previewPopup.name"
      :popUpActive="isActive.previewPopup"
      :showMoreBtn="_selectedTabId !== 'unit'"
      @go-to="$_onClickMore()"
      @click="$_onClosePopup('previewPopup')"
    />
  </PopUp>
</template>

<script>
import S_file from '@/service/api/v1/file';
import H_file from '@/helpers/file';
import H_time from '@/helpers/time';
import Spare_file from '@/spare/file';

export default {
  props: {
    popUpActive: {
      type: Boolean,
      default: false,
    },
    oneFile: {
      type: Boolean,
      default: false,
    },
    uploadModule: {
      type: String,
    },
    acceptFileType: {
      type: String,
    },
    selectedFileList: {
      type: Array,
      default: () => [],
    },
    /**
     * @description 版本模式
     * @description 空字串表示不限制，latest表示最新版本，version表示特定版本
     */
    versionMode: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isLoading: {
        content: false,
        submit: false,
      },
      isActive: {
        previewPopup: false,
      },
      tabs: {
        items: [
          {
            id: 'local',
            textLabel: '自本地上傳檔案',
          },
          {
            id: 'file',
            textLabel: '選擇來自檔案庫的檔案',
          },
          {
            id: 'unit',
            textLabel: '選擇來自其他單位的檔案',
          },
        ],
        selectedTabId: 'local',
      },
      createFile: {
        name: '',
        attaches: [],
      },
      attachType: 'latest',
      columnHeader: Spare_file.columnHeader.upload,
      filterFieldTypes: Spare_file.filterFieldTypes.upload,
      isSelectAll: false,
      selectFileList: [],
      previewPopup: {
        id: '',
        url: '',
        name: '',
      },
    };
  },
  computed: {
    _selectedTabId() {
      return this.tabs.selectedTabId;
    },
    _warningText() {
      return this._selectedTabId === 'file'
        ? '請注意，當瀏覽者未取得檔案庫該資料權限可能會看不到'
        : '請注意，檔案上傳後自動歸類至文件檔案庫「系統資料夾」，若您需要整理檔案至特定資料夾或設定權限，請至文件檔案庫進行管理。';
    },
    _fetchUrl() {
      if (this._selectedTabId === 'file') {
        return this.attachType === 'latest' ? 'file' : 'file_version/index/factory';
      } else if (this._selectedTabId === 'unit') {
        return this.attachType === 'latest' ? 'file/share/index' : 'file_version/index/share';
      } else return '';
    },
    _isSubmittable() {
      if (this._selectedTabId === 'file' || this._selectedTabId === 'unit') {
        return this.selectFileList.length > 0;
      } else {
        return this.createFile.attaches.length > 0 && this.createFile.name;
      }
    },
    _isCheckboxDisable() {
      return this.oneFile ? (this.selectFileList.length === 1 ? true : false) : false;
    },
    _attachTypeRadio() {
      const buttonItems = [
        {
          id: 'latest',
          textLabel: '最新版本 (將來此檔案有版本更新時，自動關聯至最新版本)',
        },
        {
          id: 'version',
          textLabel: '特定版本',
        },
      ];
      return {
        name: 'attachType',
        buttonItems:
          this.versionMode === ''
            ? buttonItems
            : buttonItems.filter(item => item.id === this.versionMode),
      };
    },
  },
  watch: {
    attachType() {
      this.selectFileList = [];
      this.isSelectAll = false;
    },
    _selectedTabId() {
      this.selectFileList = [];
      this.createFile = {
        name: '',
        attaches: [],
      };
    },
    'createFile.attaches': {
      handler() {
        if (this.createFile.attaches && !this.createFile.attaches.length) this.createFile.name = '';
      },
      deep: true,
    },
    versionMode: {
      handler(newVal) {
        this.attachType = newVal === '' ? 'latest' : newVal;
      },
      immediate: true,
    },
  },
  methods: {
    $_onOpenPopup(type) {
      this.isActive[type] = true;
    },
    $_onClosePopup(type) {
      if (type && this.isActive[type]) {
        this.isActive[type] = false;
        if (type === 'previewPopup') this.$_resetData('previewPopup');
      } else if (!type) {
        this.$emit('close', false);
        this.isSelectAll = false;
        this.attachType = this.versionMode === '' ? 'latest' : this.versionMode;
        this.selectFileList = [];
        this.createFile = {
          name: '',
          attaches: [],
        };
        this.tabs.selectedTabId = 'local';
      }
    },
    $_onClickTab($event) {
      const id = $event.id;
      if (this.isLoading.content || this.isLoading.submit || this.tabs.selectedTabId === id) return;
      this.tabs.selectedTabId = id;
    },
    $_onRemoveFileFromSelected(file) {
      const LvDataTable = this.$refs.LvDataTable;
      if (!LvDataTable) return;
      if (this.isSelectAll) this.isSelectAll = false;
      const tarFileIndex = LvDataTable.listData.findIndex(data => data.id === file.id);
      LvDataTable.listData[tarFileIndex].isChecked = false;
      const tarSelectedFileIndex = this.selectFileList.findIndex(_file => _file.id === file.id);
      this.selectFileList.splice(tarSelectedFileIndex, 1);
    },
    $_setParams(filterState) {
      const { search, filePath, order, duration } = filterState;
      const params = {
        order_way: 'desc',
        order_by: order,
      };
      if (search) params.search = search;
      if (filePath) params.file_path = filePath;
      if (duration) {
        params.start_time = H_time.startOf(duration.start, 'YYYY-MM-DD HH:mm:ss Z');
        params.end_time = H_time.endOf(duration.end, 'YYYY-MM-DD HH:mm:ss Z');
        params.time_field = order;
      }
      if (this.acceptFileType) params.file_type = this.$_setAcceptFileType();
      return params;
    },
    $_setAcceptFileType() {
      switch (this.acceptFileType) {
        case 'image':
          return Spare_file.imageExtensionsWithoutDot.join();
        case 'pdf':
          return Spare_file.pdfExtensionsWithoutDot.join();
        case 'xlsx':
          return Spare_file.xlsxExtensionsWithoutDot.join();
        case 'docx':
          return Spare_file.docxExtensionsWithoutDot.join();
        default:
          return;
      }
    },
    $_setListData(rawDataList) {
      return H_file.setChooseIndex(rawDataList, this._selectedTabId);
    },
    $_onLoading($event) {
      const { type, value } = $event;
      if (type === 'content') this.isLoading.content = value;
    },
    $_onSelectAll($event) {
      const LvDataTable = this.$refs.LvDataTable;
      if (!LvDataTable) return;
      this.isSelectAll = $event;
      if (!this.isSelectAll) this.selectFileList = [];
      LvDataTable.listData.forEach(file => {
        file.isChecked = this.isSelectAll;
        if (
          this.isSelectAll &&
          !this.selectFileList.find(_file => {
            if (this.attachType === 'latest') return _file.id === file.id;
            else return _file.versionId === file.versionId;
          })
        )
          this.selectFileList.push(file);
      });
    },
    $_onChangeSelectFile($event, rowItem) {
      const LvDataTable = this.$refs.LvDataTable;
      if (!LvDataTable) return;
      const fileId = rowItem.id;
      const fileVersionId = rowItem.versionId;
      const isChecked = $event;
      const tarFileIndex = LvDataTable.listData.findIndex(data => {
        if (this.attachType === 'latest') return data.id === fileId;
        else return data.versionId === fileVersionId;
      });
      if (this.oneFile) {
        if (isChecked) {
          LvDataTable.listData.forEach((data, dataIndex) => {
            if (dataIndex === tarFileIndex) data.isChecked = true;
            else data.isChecked = false;
          });
          this.selectFileList = [rowItem];
        } else {
          LvDataTable.listData[tarFileIndex].isChecked = false;
          this.selectFileList = [];
        }
      } else {
        if (this.isSelectAll && !isChecked) this.isSelectAll = false;
        LvDataTable.listData[tarFileIndex].isChecked = isChecked;
        const tarSelectedFileIndex = this.selectFileList.findIndex(data => {
          if (this.attachType === 'latest') return data.id === fileId;
          else return data.versionId === fileVersionId;
        });
        if (tarSelectedFileIndex >= 0) this.selectFileList.splice(tarSelectedFileIndex, 1);
        else this.selectFileList.push(rowItem);
      }
    },
    async $_onSubmit() {
      let result = [];
      if (this._selectedTabId === 'file' || this._selectedTabId === 'unit') {
        result = this.selectFileList
          .map(file => {
            const result = {
              ...file,
              file: file.id,
            };
            return this.attachType === 'latest'
              ? result
              : {
                  ...result,
                  fileVersion: file.versionId,
                };
          })
          .filter(file => {
            const isFileSelected = this.selectedFileList.find(
              selectedFile =>
                selectedFile.id === file.file && selectedFile.versionId === file.fileVersion,
            );
            return isFileSelected === undefined;
          });
      } else {
        const isValidate = await this.$refs.formObserver.validate();
        if (!isValidate) return;
        this.isLoading.submit = true;
        const formData = H_file.setSubmitCreateFile(this.createFile, null, this.uploadModule);
        const {
          id,
          name,
          file_type: fileType,
          version_number,
          last_version,
          source_url,
        } = await S_file.storeSystemFile(this.createFile.attaches[0].name, formData);
        const base = {
          id,
          name,
          fileType,
          versionNumber: `ver.${version_number}`,
          hasScope: true,
          url: source_url,
          isSystem: true,
        };
        if (this.versionMode === 'version') base.versionId = last_version.id;
        result = [base];
        this.isLoading.submit = false;
      }
      if (result.length) this.$emit('input', result);
      this.$_onClosePopup();
    },
    $_onClickItem($event) {
      const { id, url, name } = $event;
      this.previewPopup = { id, url, name };
      this.$_onOpenPopup('previewPopup');
    },
    $_onClickMore() {
      const url = this.$router.resolve({
        path: `/factory/${this._currentFactoryId}/file-content/${this.previewPopup.id}`,
      });
      window.open(url.href, '_blank');
    },
    $_resetData(type) {
      if (type === 'previewPopup') {
        this.previewPopup = {
          id: '',
          url: '',
          name: '',
        };
      }
    },
    $_onChooseFile($event) {
      if ($event && $event[0] && !this.createFile.name.trim())
        this.createFile.name = H_file.getFileName($event[0].name);
    },
  },
};
</script>
